module.exports = __webpack_public_path__ + "static/media/circle-view-off.02d126f1.svg";